export default "__VITE_ASSET__Ct6yM4tP__"